import { IconImage } from 'bold-ui'
import { MapMarker } from 'components/map/MapMarker'
import { TipoImovelEnum } from 'graphql/types.generated'
import { useHistory, useRouteMatch } from 'react-router'

import { PINO_TERRITORIO_MODAL_ROUTE } from '../model-territorioMapa'

interface MapaTerritorioMarkerProps {
  imovelId: string
  tipoImovel: TipoImovelEnum
}

export function MapaTerritorioMarker(props: Readonly<MapaTerritorioMarkerProps>) {
  const { imovelId, tipoImovel } = props

  const { icon, color } = TIPO_IMOVEL_MARKER_CONFIG[tipoImovel]

  const { url } = useRouteMatch()
  const history = useHistory()

  const handleClick = () => history.push(`${url}/${PINO_TERRITORIO_MODAL_ROUTE}/${imovelId}`)

  return <MapMarker icon={icon} color={color} label='Visualizar detalhes do imóvel' onClick={handleClick} />
}

interface TipoImovelPinoConfig {
  icon: IconImage
  color?: string
}

const TIPO_IMOVEL_MARKER_CONFIG: Record<TipoImovelEnum, TipoImovelPinoConfig> = {
  [TipoImovelEnum.DOMICILIO]: { icon: 'houseFilled' },
  [TipoImovelEnum.CASAI]: { icon: 'houseFilled' },
  [TipoImovelEnum.COMERCIO]: { icon: 'shoppingCartFilled' },
  [TipoImovelEnum.TERRENO_BALDIO]: { icon: 'leafFilled' },
  [TipoImovelEnum.ESCOLA]: { icon: 'graduateCap' },
  [TipoImovelEnum.CRECHE]: { icon: 'babyTreeFilled' },
  [TipoImovelEnum.ABRIGO]: { icon: 'shieldFilled' },
  [TipoImovelEnum.INSTITUICAO_LONGA_PERMANENCIA_PARA_IDOSOS]: { icon: 'sixtyPlus' },
  [TipoImovelEnum.UNIDADE_PRISIONAL]: { icon: 'prison' },
  [TipoImovelEnum.UNIDADE_MEDIDA_SOCIOEDUCATIVA]: { icon: 'balanceFilled' },
  [TipoImovelEnum.DELEGACIA]: { icon: 'policeBadge' },
  [TipoImovelEnum.ESTABELECIMENTO_RELIGIOSO]: { icon: 'candle' },
  [TipoImovelEnum.PONTO_ESTRATEGICO]: { icon: 'target' },
  [TipoImovelEnum.OUTROS]: { icon: 'mapMarkerFilled' },
}
